import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';
import { useGlobalStore } from '@/features/Global/store';

export class Elementar extends AbstractRequirementMapper {
  protected frontendKey = new Map(
    Object.entries({
      woh: 'absicherungen.elementar',
      hau: 'elementarversicherung',
    }),
  );

  public getValues(): number[] | boolean[] {
    if (useGlobalStore().sparte === 'woh') {
      return super.getValues();
    }

    return super.getValues().map((v) => Number.parseInt(<string>v, 10));
  }
}
